import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { usePageMeta } from '../hooks/usePageMeta';

const SECTIONS = [
  {
    heading: 'Our sources',
    paragraphs: ['We base every guide on official and trusted guidance, in this order:'],
    ordered: [
      'Government and international health bodies: WHO, ICMR–National Institute of Nutrition (including the Dietary Guidelines for Indians), India’s Ministry of Health and Family Welfare.',
      'National health services and agencies elsewhere, such as the UK’s NHS and the US CDC.',
      'Large, well-regarded research studies and reviews.',
    ],
    after: 'We link the main sources at the end of every guide.',
  },
  {
    heading: 'How we write',
    bullets: [
      'Plain language, Indian examples and practical steps.',
      'We separate what is well established from what is still uncertain, and we say so.',
      'We use "linked with" when research shows an association, and "causes" only when the evidence shows cause.',
    ],
  },
  {
    heading: 'What we do not do',
    bullets: [
      'We do not diagnose conditions, recommend medicines or doses, or interpret test results.',
      'We do not promote supplements, products or extreme diets.',
      'Our guides do not claim to be medically reviewed. We are an editorial team, not a medical panel.',
      'Every guide that touches health includes a "When to see a doctor" section.',
    ],
  },
  {
    heading: 'Keeping guides up to date',
    paragraphs: [
      'Each guide shows the date it was last updated. We review every guide at least once a year, and sooner when official guidance changes.',
    ],
  },
  {
    heading: 'Corrections',
    paragraphs: [
      'If you spot an error, please write to hello@overall-wellbeing.com with "Correction" in the subject. We aim to reply within 7 working days and to fix confirmed errors promptly.',
    ],
  },
  {
    heading: 'Independence',
    paragraphs: [
      'We do not accept sponsored content. If we ever add affiliate links or partnerships, we will label them clearly on the page.',
      'Some images on this site are created with AI tools and are illustrative only.',
    ],
  },
];

export default function EditorialStandards() {
  usePageMeta({
    title: 'How we create our guides | OVERALL WELLBEING',
    description:
      'Our sources, how we write, what we do not do, and how we keep our guides up to date.',
    path: '/editorial-standards',
  });

  return (
    <LegalLayout
      testId="editorial-standards-page"
      eyebrow="Editorial standards"
      title="How we create our guides"
      intro="Every guide on OVERALL WELLBEING follows the same simple rules: trusted sources, plain language, and a clear line between what is well established and what is still uncertain."
      sections={SECTIONS}
    />
  );
}
